import { EMPTY_STRING } from '../../../../constants/common'
import { AIButtonContainedGrey } from '../../../AIButton'
import Text from '../../../Text'
import { QA_NAME_GRETA_AI_CHAT_CHAT_LIST_RETRY } from '../GretaAIChatChatList.constants'

import * as styles from './GretaAIChatChatListPlaceholder.module.css'

function GretaAIChatChatListPlaceholder({
  retryText = EMPTY_STRING,
  text = EMPTY_STRING,
  title = EMPTY_STRING,
  onRetry = null,
}) {
  return (
    <div className={styles.placeholder}>
      <Text Element='p' className={styles.placeholderTitle}>
        {title}
      </Text>

      {text ? (
        <Text isSecondary Element='p' className={styles.placeholderText}>
          {text}
        </Text>
      ) : null}

      {onRetry ? (
        <AIButtonContainedGrey
          qaName={QA_NAME_GRETA_AI_CHAT_CHAT_LIST_RETRY}
          text={retryText}
          onClick={onRetry}
        />
      ) : null}
    </div>
  )
}

export default GretaAIChatChatListPlaceholder
